import * as React from "react";
import { singleton } from "logic/singleton";
const HandlerContext = React.createContext(void 0);
export default singleton("contexts.SearchFiltersHandlerContext", () => HandlerContext);
